<template>
  <div class="indexPage identityAuthPage">
    <job-header-simple header_title="身份认证"></job-header-simple>
    <div class="uploadSection">
        <van-cell 
            @click="showCardImg"
            class="pictureUploadVanCell" 
            title-class="pictureUploadTitle"  
            title="身份证图片" 
            is-link 
            :arrow-direction="isShowImg?'up':'down'" 
            value="" /> 
        <div v-if="isShowImg" class="img-content">
            <div class="item">
                <div id="bg_front">
                <van-uploader
                    @delete="deleteImg('frontPic')"
                    v-model="frontPicArr"
                    :max-count="1"
                    :before-read="beforeReadFront"
                >
                    <div id="frontPic" class="bg_front"></div>
                </van-uploader>
                </div>
                <van-loading type="spinner" color="#6c7ef3" v-if="frontPicLoading" />
            </div>
            <div class="item">
                <div id="bg_back">
                <van-uploader
                    @delete="deleteImg('backPic')"
                    v-model="backPicArr"
                    :max-count="1"
                    :before-read="beforeReadBack"
                >
                    <div id="backPic" class="bg_back"></div>
                </van-uploader>
                </div>
                <van-loading type="spinner" color="#6c7ef3" v-if="backPicLoading" />
            </div>

            <van-divider>照片上传要求</van-divider>
            <div class="img">
                <img src="@/assets/error_example.png" alt />
            </div>
        </div>
      
    </div>
    <div  class="userCardInfo pictureUploadContent">
        <header class="header-title">个人信息</header>
        <ul class="userCardInfoContent">
            <li class="userCardInfoContentItem" v-for="(item,index) in infoList"  :key="'info-list'+index" v-if="isShowItem(item)">
                <p class="label">
                    <label>
                        {{ item.label }}<i></i>
                    </label>
                   
                </p>
                {{ item.value }}
            </li>
            <li class="userCardInfoContentItem" v-if="type!=='card'&&type!=='face'">
                <p class="label" >
                    <template v-if="type==='telecom3'">
                        <label>
                            手机号<i></i>
                        </label>
                        
                    </template>
                    <template v-else>
                        预留手机号
                    </template>   
                </p>
                <input 
                v-if="type==='telecom3'"
                v-model="cardInfo.mobile"
                v-number-only
                pattern="[0-9]*"
                class="pone-input" 
                id="input-area" 
                rows="1" 
                maxlength="11" 
                type="number"  
                placeholder="请输入当前账户绑定手机号"/>
                <input 
                v-else
                v-model="cardInfo.phone"
                v-number-only
                pattern="[0-9]*"
                class="pone-input" 
                id="input-area" 
                rows="1" 
                maxlength="11" 
                type="number"  
                placeholder="请输入银行卡预留手机号"/>
            </li>
        </ul> 
    </div>
    <div class="btn_box">
      <van-button
        type="info"
        size="large"
        @click="handleIndentify"
        class="btn_theme"
        >认证</van-button
      >
    </div>
    <van-dialog 
        v-model="showCode"
        :showCancelButton="true"
        confirmButtonText="确认提交"
        class="codeDialog"
        :before-close="optionAuthentication"
        >
      <div class="getCodeContent">
          <p class="title">
            短信验证
          </p>
        <p>
          <label>
            当前手机：
          </label> 
          <template v-if="type==='telecom3'">
                {{ cardInfo.mobile }}
            </template>
            <template v-else>
                {{ cardInfo.phone }}
            </template>
        
          
        </p>
        <van-field class="getCode" v-model="cardInfo.code" clearable placeholder="请填写验证码" :border="input_border">
        <template slot="button">
            <span class="countDownBox"  v-show="isOn">
                <van-count-down
                ref="countDown"
                :auto-start="false"
                @finish="countFinished"
                :time="time"
                format="ss"
                class="i-text"
                />
                秒后可重新获取
            </span>
           
            <span @click="handleCode" class="optBtn" v-show="!isOn">{{ codeText }}</span>
        </template>
        </van-field>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import {
  Uploader,
  button,
  Divider,
  Dialog,
  Toast,
  Loading,
  Overlay,
  Cell,
  Field,
  CountDown
} from "vant";
import { mapGetters } from "vuex";
import jobHeaderSimple from "@/components/header/header.vue";
import api from "@/api/list";
import Exif from "exif-js";
import { browserUA } from '@/utils/browserUA'
export default {
  components: {
    [Uploader.name]: Uploader,
    [button.name]: button,
    [Divider.name]: Divider,
    [Dialog.name]: Dialog,
    [Toast.name]: Toast,
    [Loading.name]: Loading,
    [Overlay.name]: Overlay,
    [Cell.name]: Cell,
    [Field.name]: Field,
    [CountDown.name]: CountDown,
    [Dialog.Component.name]: Dialog.Component,
    jobHeaderSimple,
  },
  data() {
    return {
      codeText:'获取验证码',
      time: 60 * 1000, //1分钟
      type : this.$route.query.type || 'bankcard4',//认证类型
      input_border: false,
      showCode:false,//是否显示获取验证码弹框
      isOn:false,
      frontPicArr: [],
      backPicArr: [],
      isShowImg:true,
      originfrontPic:"",//用于保存原来的图片
      originbackPic:"",//用于保存原来的图片
      frontPic: "",
      backPic: "",
      frontPicLoading: false,
      backPicLoading: false,
      infoList:[
        {
            label:"姓名",
            value:"",
            key:"name"
        },
        {
            label:"证件号码",
            value:"",
            key:"idNumber"
        },
        {
            label:"银行卡号",
            value:"",
            key:"bankCard"
           
        },
        {
            label:"银行名称",
            value:"",
            key:"bankName"
        }
      ],
      cardInfo:{
        name:"",
        idNumber:"",
        bankCard:"",
        bankName:"",
        phone:"",
        code:"",
        mobile:""
      },
      val: {
        bank_name: "",
        account: "",
      },
    };
  },
  directives:{
    numberOnly:{
        bind:function(e){
            e.handler = function(){
                e.value = e.value.replace(/\d+/,'')
            }
            // e.addEventListener('input',e.handler)
        },
        unbind:function(e){
            e.removeEventListener('input',e.handler)
        }
    }
  },
  watch: {
    frontPicArr: function (now) {
      let that = this;
      let img = document.getElementById("bg_front");
      if (!now.length) {
        img.style.backgroundImage = "none";
        return;
      }
      this.imgPreview(now[0].file, function (data) {
        that.frontPic = data;
        img.style.backgroundImage = `url(${that.frontPic})`;
        that.frontPicLoading = false;
      });
    },
    backPicArr: function (now) {
      let that = this;
      let img = document.getElementById("bg_back");
      if (!now.length) {
        img.style.backgroundImage = "none";
        return;
      }
      this.imgPreview(now[0].file, function (data) {
        that.backPic = data;
        img.style.backgroundImage = `url(${that.backPic})`;
        that.backPicLoading = false;
      });
    },
    userInfo: {
      handler: function (val, oldVal) {
        try {
            this.infoList[0].value = val.name;
            this.infoList[1].value = val.idNumber;
            this.cardInfo.name = val.name;
            this.cardInfo.idNumber = val.idNumber;
            this.cardInfo.mobile = val.mobile;
   
            if(val.front){
                this.showImage()
            }
         
        } catch (error) {
            
        }
        
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ...mapGetters([
      "userInfo"
    ]),
  },
  mounted() {
    this.initData();
  },
  created() {
  
  },
  methods: {
    //获取验证码
    handleCode() {     
        let phones =  this.cardInfo.phone;
        if(this.type==='telecom3'){
            phones = this.cardInfo.mobile;
        }
        if (!(/^[1][0-9]{10}$/.test(phones))) { 
            this.$toast("手机号码格式不正确！");
            return false;
        }

      api
        .reSendAuthCode({ mobile: phones,identityType:this.type },{ method: "post" })
        .then((res) => {
          if (res.data.status == "200") {
            this.isOn = true;
            this.$refs.countDown.start();
            this.codeText = "重新获取";
          } else {
            this.$toast(res.data.message);
          }
         
        })
        .catch((error) => {
            this.isOn = false;
            // this.$toast();
        });
    },
    countFinished() {
      this.isOn = false;
      this.$refs.countDown.reset();
    },
    isShowItem(data){
        let flag = true
        if(this.type==='telecom3'){
            if(data.key === 'bankCard'||data.key === 'bankName'){
                flag = false
            }  
        }
        return flag;

    },
    initData(){
        // if(this.$route.query.front&&this.$route.query.back){
        //     let front = process.env.VUE_APP_FILE_PATH+this.$route.query.front;
        //     this.getBase64(front,dataURL=>{
        //             this.frontPic = dataURL;
        //             this.originfrontPic = dataURL;
        //             let img = document.getElementById("frontPic");
        //             img.style.backgroundImage = `url(${this.frontPic})`;
        //             this.frontPicLoading = false;
                    
        //     })
        //     let back = process.env.VUE_APP_FILE_PATH+this.$route.query.back;
        //     this.getBase64(back,dataURL=>{
        //             this.backPic = dataURL; 
        //             this.originbackPic = dataURL;
        //             let img = document.getElementById("backPic");
        //             img.style.backgroundImage = `url(${this.backPic})`;
        //             this.backPicLoading = false;      
        //     })
        // }
        if(this.userInfo&&this.userInfo.front){
            this.showImage()
        }
        try{
            this.infoList[2].value = this.$route.query.bankCard
            this.infoList[3].value = this.$route.query.bankName
            this.cardInfo.bankCard =  this.$route.query.bankCard
            this.cardInfo.bankName = this.$route.query.bankName
            this.cardInfo.phone = this.$route.query.bankMobile
            
        }catch{

        }
        
   
    },
    showImage(){
    
            let front = process.env.VUE_APP_FILE_PATH+this.userInfo.front;
            this.getBase64(front,dataURL=>{
             
                    this.frontPic = dataURL;
                    this.originfrontPic = dataURL;
                    let img = document.getElementById("frontPic");
                    img.style.backgroundImage = `url(${this.frontPic})`;
                    this.frontPicLoading = false;
                    
            })
            let back = process.env.VUE_APP_FILE_PATH+this.userInfo.back;
            this.getBase64(back,dataURL=>{
                    this.backPic = dataURL; 
                    this.originbackPic = dataURL;
                    let img = document.getElementById("backPic");
                    img.style.backgroundImage = `url(${this.backPic})`;
                    this.backPicLoading = false;      
            })
    },
    //点击展开图片详情
    showCardImg(){
        this.isShowImg = !this.isShowImg;
    },
    deleteImg(type){
        if(this['origin'+type]!==""){
            this[type] = this['origin'+type];
            let that = this;
            let cTimer = setTimeout(function(){
                clearTimeout(cTimer)
                let img =  document.getElementById(type);
                img.style.backgroundImage = `url(${that[type]})`;
            },0)   
        }
       
    },
    beforeReadFront(file) {
      if (
        file.type !== "image/jpeg" &&
        file.type !== "image/png" &&
        file.type !== "application/x-jpg" &&
        file.type !== "image/bmp"
      ) {
        Toast("请上传 jpg,png,jpeg,bmp 格式图片");
        return false;
      }
      this.frontPicLoading = true;
      return true;
    },
    beforeReadBack(file) {
      if (
        file.type !== "image/jpeg" &&
        file.type !== "image/png" &&
        file.type !== "application/x-jpg" &&
        file.type !== "image/bmp"
      ) {
        Toast("请上传 jpg,png,jpeg,bmp 格式图片");
        return false;
      }
      this.backPicLoading = true;
      return true;
    },
    //关闭手机号校验的弹窗
    optionAuthentication(action,done){
        if(action==='confirm'){ //点击的是确定
        if(this.cardInfo.code===""||this.cardInfo.code==undefined){
            Toast.fail("请填写验证码!")
            done(false)
            return false;
        }
        Toast.loading({
          mask: true,
          message: "验证中...",
          duration: 0,
        });
        api.authCodeAudit(
            {
                authcode:this.cardInfo.code,//验证码
                identityType:this.type,
                bankCard: this.$route.query.bankCard
            },{
                method:'post'
            }
        ).then((res)=>{
         
           if(res.data.status===200){
         
            var papersType = this.$route.query.papersType;
            let msg = "";
                if (papersType !== "1") {
                  msg = "上传成功";
                } else {
                  msg = "认证成功，即将跳转！";
                }
                Toast.clear();
                // 如果请求后台验证成功则后台改为已认证状态，并重定向回之前页面
                Toast.loading({
                  duration: 3000, // 持续展示 toast
                  forbidClick: true, // 禁用背景点击
                  loadingType: "spinner",
                  message: msg,
                });
                
                this.$router.push({
                  path: "/contractBase",
                  query: { obj: this.$route.query.contractId, val: this.val },
                });
                done(true)
           }else{ //业务错误
            done(false)
            Toast.fail("验证码校验失败")
           }
          
        }).catch(err=>{
           
            Toast.clear();
            done(false)
        })
        }else{
            done()
        }
    },
    // 手机号校验
    confirmAuthentication(){
        Toast.loading({
          mask: true,
          message: "验证中...",
          duration: 0,
        });
        api.authCodeAudit(
            {
                authcode:this.cardInfo.code,//验证码
                identityType:this.type,
                bankCard: this.$route.query.bankCard
            },{
                method:'post'
            }
        ).then((res)=>{
           if(res.data.status==200){
            var papersType = this.$route.query.papersType;
            let msg = "";
                if (papersType !== "1") {
                  msg = "上传成功";
                } else {
                  msg = "认证成功，即将跳转！";
                }
                Toast.clear();
                // 如果请求后台验证成功则后台改为已认证状态，并重定向回之前页面
                Toast.loading({
                  duration: 3000, // 持续展示 toast
                  forbidClick: true, // 禁用背景点击
                  loadingType: "spinner",
                  message: msg,
                });
                
                this.$router.push({
                  path: "/contractBase",
                  query: { obj: this.$route.query.contractId, val: this.val },
                });
           }else{ //业务错误
            Toast.fail("验证码校验失败")
           }
        }).catch(err=>{
            Toast.clear();
        })
    },
    //认证 四要素 和运营商三要素
    authentication4(){
        let phones =  this.cardInfo.phone;
        if(this.type==='telecom3'){
            phones = this.cardInfo.mobile;
        }
        if (!(/^[1][0-9]{10}$/.test(phones))) { 
            this.$toast("手机号码格式不正确！");
            return false;
        }
        api
          .idImage2(
            {
              front: this.frontPic,
              back: this.backPic,
              bankCard: this.$route.query.bankCard
                ? this.$route.query.bankCard.replace(/\s/g, "")
                : "",
              mobileNo:phones,
              identityType:this.type
              // bankName: this.$route.query.bankName,
              // contractId: this.$route.query.contractId
            },
            { method: "post" }
          )
          .then((res) => {
            if (res.status == "200") {
              var papersType = this.$route.query.papersType;
              if (res.data.status != "200") {
                Toast.clear();
                if (papersType !== "1") {
                  Toast.fail("上传失败," + res.data.message);
                } else {
                  Toast.fail("认证失败," + res.data.message);
                }
                return;
              } else if (res.data.status == "200") {
                if(res.data.data&&res.data.data==='junziqian'){
                    Toast.success("认证成功");
                    this.$router.push({
                    path: "/contractBase",
                    query: { obj: this.$route.query.contractId, val: this.val },
                    });
                    return false
                }
                Toast.clear();
                this.showCode=true;
                this.$nextTick(()=>{
                    this.isOn = false;
                    this.$refs.countDown.reset();
                })
            
              }
            } else {
              //验证失败，请检查上传照片是否完成
              this.$toast({
                message: res.message,
              });
            }
          });
    },
    //人脸认证
    authenticationFace(){
        debugger
      let param ={
                  front: this.frontPic,
                  back: this.backPic,
                  bankCardId: this.$route.query.bankCardId,
                  contractId: this.$route.query.contractId
            }
            api.individualFace(param,{ method: "post" }).then((res) => {
              if (res.status == '200') {
                let json = JSON.parse(res.data.data)
                if (json == null) {
                  Toast.fail(res.data.message)
                } else {
                  browserUA().then((browserType) => {
                    if (browserType == 'androidAPP') {
                      window.VpShopJs.bodyCheck(
                        JSON.stringify({ url: json.url })
                      )
                    } else {
                      location.href = json.url
                    }
                  })
                }
              } else {
                Toast.fail('发起认证失败')
              }
            })
    },
    //认证 银行卡三要素
    authentication3(){

        api
          .idImage(
            {
              front: this.frontPic,
              back: this.backPic,
              bankCard: this.$route.query.bankCard
                ? this.$route.query.bankCard.replace(/\s/g, "")
                : "",
              // bankName: this.$route.query.bankName,
              // contractId: this.$route.query.contractId
            },
            { method: "post" }
          )
          .then((res) => {
            if (res.status == "200") {
              var papersType = this.$route.query.papersType;
              if (res.data.status != "200") {
                Toast.clear();
                if (papersType !== "1") {
                  Toast.fail("上传失败," + res.data.message);
                } else {
                  Toast.fail("认证失败," + res.data.message);
                }
                return;
              } else if (res.data.status == "200") {
                Toast.clear();
                var msg = "";
                if (papersType !== "1") {
                  msg = "上传成功";
                } else {
                  msg = "认证成功，即将跳转！";
                }
                //如果请求后台验证成功则后台改为已认证状态，并重定向回之前页面
                Toast.loading({
                  duration: 3000, // 持续展示 toast
                  forbidClick: true, // 禁用背景点击
                  loadingType: "spinner",
                  message: msg,
                });
                this.$router.push({
                  path: "/contractBase",
                  query: { obj: this.$route.query.contractId, val: this.val },
                });
                // let second = 3;
                // const timer = setInterval(() => {
                //   second--;
                //   if (second) {
                //     toast.message = `倒计时 ${second} 秒`;
                //   } else {
                //     clearInterval(timer);
                //
                //   }
                // }, 1000);
                //   Toast.clear();
              }
            } else {
              //验证失败，请检查上传照片是否完成
              this.$toast({
                message: res.message,
              });
            }
          });
    },
    handleIndentify() {
      this.val.bank_name = this.$route.query.bankName;
      this.val.account = this.$route.query.bankCard;
      if (this.frontPic == "" || this.backPic == "") {
        Dialog.alert({
          title: "提示",
          message: "请确认是否上传完整的证件正反面!",
        }).then(() => {});
      } else {
        if(this.type!=='card'&&this.type!=='face'){
            let phone = this.type==='telecom3'?this.cardInfo.mobile:this.cardInfo.phone
            if (!(/^[1][0-9]{10}$/.test(phone))) { 
                Dialog.alert({
                title: "提示",
                message: "请输入正确的手机号!",
                }).then(() => {});
                return false
            }
        }
        Toast.loading({
          mask: true,
          message: "认证中...",
          duration: 0,
        });
        if(this.type==='face'){ //人脸
                this.authenticationFace();
        }else{
            if(this.type==='card'){
                this.authentication3();
            }else{
                this.authentication4();
            }
        }
    

      }
    },
    // url 转base64
     getBase64(url, callback) {
        var Img = new Image(),
            dataURL = '';
        Img.src = url + '?v=' + Math.random();
        Img.setAttribute('crossOrigin', 'Anonymous');
        Img.onload = function() {
            var canvas = document.createElement('canvas'),
            width = Img.width,
            height = Img.height;
            canvas.width = width;
            canvas.height = height;
            canvas.getContext('2d').drawImage(Img, 0, 0, width, height);
            dataURL = canvas.toDataURL('image/jpeg');
            return callback ? callback(dataURL) : null;
        };
    },
    imgPreview(file, callback) {
      let self = this;
      let Orientation;
      //去获取拍照时的信息，解决拍出来的照片旋转问题
      Exif.getData(file, function () {
        Orientation = Exif.getTag(this, "Orientation");
      });
      // 看支持不支持FileReader
      if (!file || !window.FileReader) return;

      if (/^image/.test(file.type)) {
        // 创建一个reader
        let reader = new FileReader();
        // 将图片2将转成 base64 格式
        reader.readAsDataURL(file);
        // 读取成功后的回调
        reader.onloadend = function () {
          let result = this.result;
          let img = new Image();
          img.src = result;
          //判断图片是否大于100K,是就直接上传，反之压缩图片
          if (this.result.length <= 100 * 1024) {
            callback(this.result);
          } else {
            img.onload = function () {
              let data = self.compress(img, Orientation);
              callback(data);
            };
          }
        };
      }
    },
    compress(img, Orientation) {
      let canvas = document.createElement("canvas");
      let ctx = canvas.getContext("2d");
      //瓦片canvas
      let tCanvas = document.createElement("canvas");
      let tctx = tCanvas.getContext("2d");
      //let initSize = img.src.length;
      let width = img.width;
      let height = img.height;
      //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
      let ratio;
      if ((ratio = (width * height) / 4000000) > 1) {
        //console.log("大于400万像素");
        ratio = Math.sqrt(ratio);
        width /= ratio;
        height /= ratio;
      } else {
        ratio = 1;
      }
      canvas.width = width;
      canvas.height = height;
      //        铺底色
      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      //如果图片像素大于100万则使用瓦片绘制
      let count;
      if ((count = (width * height) / 1000000) > 1) {
        //console.log("超过100W像素");
        count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片
        //            计算每块瓦片的宽和高
        let nw = ~~(width / count);
        let nh = ~~(height / count);
        tCanvas.width = nw;
        tCanvas.height = nh;
        for (let i = 0; i < count; i++) {
          for (let j = 0; j < count; j++) {
            tctx.drawImage(
              img,
              i * nw * ratio,
              j * nh * ratio,
              nw * ratio,
              nh * ratio,
              0,
              0,
              nw,
              nh
            );
            ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
          }
        }
      } else {
        ctx.drawImage(img, 0, 0, width, height);
      }
      //修复ios上传图片的时候 被旋转的问题
      if (Orientation != "" && Orientation != 1) {
        switch (Orientation) {
          case 6: //需要顺时针（向左）90度旋转
            this.rotateImg(img, "left", canvas);
            break;
          case 8: //需要逆时针（向右）90度旋转
            this.rotateImg(img, "right", canvas);
            break;
          case 3: //需要180度旋转
            this.rotateImg(img, "right", canvas); //转两次
            this.rotateImg(img, "right", canvas);
            break;
        }
      }
      //进行最小压缩
      let ndata = canvas.toDataURL("image/jpeg", 0.1);
      tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
      return ndata;
    },
    rotateImg(img, direction, canvas) {
      //最小与最大旋转方向，图片旋转4次后回到原方向
      const min_step = 0;
      const max_step = 3;
      if (img == null) return;
      //img的高度和宽度不能在img元素隐藏后获取，否则会出错
      let height = img.height;
      let width = img.width;
      let step = 2;
      if (step == null) {
        step = min_step;
      }
      if (direction == "right") {
        step++;
        //旋转到原位置，即超过最大值
        step > max_step && (step = min_step);
      } else {
        step--;
        step < min_step && (step = max_step);
      }
      //旋转角度以弧度值为参数
      let degree = (step * 90 * Math.PI) / 180;
      let ctx = canvas.getContext("2d");
      switch (step) {
        case 0:
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0);
          break;
        case 1:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(degree);
          ctx.drawImage(img, 0, -height);
          break;
        case 2:
          canvas.width = width;
          canvas.height = height;
          ctx.rotate(degree);
          ctx.drawImage(img, -width, -height);
          break;
        case 3:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(degree);
          ctx.drawImage(img, -width, 0);
          break;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.uploadSection {
  margin: 8px 12px;
  background: #fff;
//   padding: 28px 20px 10px;
  padding: 0px 20px;
  border-radius: 6px;
  .img-content{
    padding-bottom: 20px;
  }
  .pictureUploadVanCell{
    font-size: 16px;
    padding: 12px 0;
    // color: rgb(51,51,51);
    color: #6c7ef3;
    font-weight: bold;
    font-family: 'SourceHanSansSC-Bold';
    &.van-cell--clickable:active{
        background: #fff;
    }
    .van-icon{
        color: #6c7ef3;
        // color: rgb(51,51,51);
    }
  }
  .item {
    position: relative;
    width: 250px;
    height: 122px;
    background: #ebecf4;
    border-radius: 2px;
    margin: 0 auto 18px;
    text-align: center;
    padding: 11px;

    & > div {
      height: 122px;
      background-position: center center;
      background-size: contain;
      background-repeat: no-repeat;
    }

    .van-loading {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      padding-top: 55px;
      background: rgba(0, 0, 0, 0.6);
    }

    /deep/ .van-uploader {
      height: 122px;
      //overflow: hidden;
    }

    /deep/ .van-uploader__preview {
      margin: 0;
    }

    /deep/ .van-uploader__preview-image {
      max-width: 250px;
      max-height: 122px;
      width: auto;
      height: auto;
      text-align: center;
    }

    /deep/ .van-image__img {
      display: inline-block;
      opacity: 0;
      max-width: 100%;
      max-height: 100%;
      width: auto;
      height: auto;
    }
  }
}
.userCardInfo{
    background: #fff;
    margin: 12px 12px 0;
    border-radius: 6px;
    .userCardInfoContent{
        background: #fff;
        padding: 0 20px 12px;
        border-radius: 6px;
        // margin-top: 8px;
        .userCardInfoContentItem{
            display: flex;
            align-items: center;
            font-size: 15px;
            height: 38px;
            .label{
                width: 100px;
               
                display: flex;
                align-items: center;
                justify-content: center;
                label{
                    display: block;
                    height:38px;
                    line-height: 38px;
                    width: 65px;
                    text-align: justify;
                    i{
                        display:inline-block;
                        padding-left: 100%;
                        width: 100%;
                    }
                }
            }
            .pone-input{
                border: none;
                padding: 0;
            }
            .pone-input::input-placeholder{
                color: #969799;
                font-size: 14px;
            }
            .pone-input::-webkit-input-placeholder{
                color: #969799;
                font-size: 14px;
            }
            .pone-input::-moz-placeholder{
                color: #969799;
                font-size: 14px;
            }
            .pone-input::-ms-input-placeholder{
                color: #969799;
                font-size: 14px;
            }
        }
    }
    .header-title{
        font-size: 16px;
        padding: 12px 20px;
        border-radius: 6px 6px 0 0;
        color: #6c7ef3;
        // color: rgb(51,51,51);
        font-weight: bold;
        font-family: 'SourceHanSansSC-Bold';
    }
}
.bg_front {
  display: block;
  width: 193px;
  height: 121px;
  background: url("../../assets/bg_front.png") center center no-repeat;
  background-size: contain;
}

.loading {
  z-index: 99999;
  margin-left: auto;
  margin-right: auto;
}

.bg_back {
  display: block;
  width: 193px;
  height: 121px;
  margin: 0 auto;
  background: url("../../assets/bg_back.png") center center no-repeat;
  background-size: contain;
}

.img {
  margin-top: -10px;
  img {
    display: block;
    width: 100%;
    height: auto;
  }
}

.btn_box {
  padding: 38px 44px 0;
}
.getCodeContent{
    padding: 20px 20px 0;
    font-size: 14px;
    font-family: 'SourceHanSansSC-Medium';
    .title{
        width: 100%;
        text-align: center;
        font-size: 18px;
        font-family: 'SourceHanSansSC-Bold';
        margin: 12px 0;
       
    }
    .getCode{
        padding-left: 4px;
        padding-right: 4px;
        border-bottom: 1px solid #ccc;
        margin-top: 10px;
        .optBtn{
            margin-right: 20px;
            color: #6C7EF3;
        }
        .countDownBox{
            display: flex;
            align-items: center;
        }
    }
}

</style>
<style lang="less">
.identityAuthPage {
    .codeDialog{
    [class*=van-hairline]:after{
        border: none;
    }
    .van-button__content{
        width: 108px;
        text-align: center;
        border: 1px solid  rgb(51, 51, 51);
        height: 36px;
        border-radius: 6px;
        margin-right: 6px;
    }
    .van-button{
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin: 12px 0 8px;
        &.van-dialog__confirm{
            justify-content: flex-start;
            .van-button__content{
                margin-right: 0;
                margin-left: 6px;
                background: #6c7ef3;
                color: #fff;
                border-color: #6c7ef3;
            }
        }
    }
}
}

</style>


